import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { jwtDecode } from 'jwt-decode';
import { URLConst } from '../shared/const/url.const';
import { EnvironmentconfigService } from '../shared/service/environmentconfig.service';
import { WebApiService } from '../shared/service/webapi.service';
import { LayoutService } from '../shared/auth/layout-service';
import { AuthService } from '../shared/auth/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})


export class LayoutComponent implements OnInit {
  isCollapsed: boolean;
  langueBooleanCN: boolean;
  langueBooleanTW: boolean;
  langueBooleanEN: boolean;
  langueBooleanVN: boolean;
  listtimedata: any;
  Routerurl: boolean = false;
  isReady = false;
  constructor(
    private WebApiService: WebApiService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private Router: Router,
    private msalService: MsalService,
    private layoutServ: LayoutService,
    private authServ: AuthService
  ) {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === `entraAccessToken` || event.key === 'switchedUserToken' || event.key === 'IdentitySwitchFlag') {
        //登入狀態有變化,直接刷新頁面自動更新用戶信息
        setTimeout(() => {
          let needRefresh = true;
          //如果是entraAccessToken,額外檢查是否token變了但其實用戶沒變
          if (event.key === 'entraAccessToken') {
            //解析token獲取用戶id
            const newToken = event.newValue;
            const oldToken = event.oldValue;
            if (newToken && oldToken) {
              const subNew = jwtDecode<{ sub?: string }>(newToken);
              const subOld = jwtDecode<{ sub?: string }>(oldToken);
              if (subNew.sub === subOld.sub) {
                //用戶沒變,不刷新頁面
                needRefresh = false;
              }
            }
          }
          if (needRefresh) {
            if (event.key === 'entraAccessToken' && !event.newValue) {
              //entra token被清空，代表是登出，導到login頁面
              this.authServ.logoutAndClearAll();
            } else {
              //其他情況代表用戶切換，導到callback刷新menu
              window.location.href = 'login/callback';
            }
          }
        }, 2000) //延遲處理，避免多tab同時操作導致的意外衝突
      }
    });
  }

  handleCollapsed(ev): void {
    this.isCollapsed = ev;

  }
  async ngOnInit() {
    this.authServ.refreshToken().then(async token => {
      this.setEntraTokenAutoRefresh();
      await this.layoutServ.setUserInfo();
      const user = this.authServ.getCurrentUserInfo();
      if (!user || !user.email) {
        //导回login页面,錯誤信息在setUserInfo中顯示5秒，這邊延遲5秒再登出
        await new Promise<void>((resolve) => {
          setTimeout(() => { resolve(); }, 5000);
        });
        this.authServ.logoutAndClearAll();
        return;
      }

      this.isReady = true;

      this.getannouncement()
      //this.Routerurl =this.Router.url
      this.geturl()
    }).catch(err => {
      console.error('Initial token acquisition failed:', err);
    });
  }

  setEntraTokenAutoRefresh() {
    setInterval(() => {
      this.authServ.refreshToken();
    }, 180 * 1000);//每3分鐘檢查一次
  }

  geturl() {
    if (this.Router.url == '/pages/wmsm-pages' || this.Router.url == '/pages') {
      this.Routerurl = true
    } else {
      this.Routerurl = false
    }

    //this.Top.gecrumbs()
  }

  getannouncement() {
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetNoticeList.url}?type=` + '0' + '&LoginId=' + this.authServ.getCurrentUserInfo().userId;
    const params = {
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        let language = sessionStorage.getItem("wmsmlang");
        this.langueBooleanCN = false
        this.langueBooleanTW = false
        this.langueBooleanEN = false
        this.langueBooleanVN = false
        if (language == "zh-CN") {
          this.langueBooleanCN = true
        } else if (language == "zh-TW") {
          this.langueBooleanTW = true
        } else if (language == "en") {
          this.langueBooleanEN = true
        }

        else if (language == "VN") {
          this.langueBooleanVN = true
        }
        this.listtimedata = res.data
      },
      (error) => {
      }
    );
  }
}
